import { render } from "./Flight_settings.vue?vue&type=template&id=438c3714&scoped=true"
import script from "./Flight_settings.vue?vue&type=script&lang=js"
export * from "./Flight_settings.vue?vue&type=script&lang=js"

import "./Flight_settings.vue?vue&type=style&index=0&id=438c3714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438c3714"]])

export default __exports__